"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  pullText: 'pull down to refresh',
  dropText: 'release to refresh',
  loadingText: 'loading',
  successText: 'loaded successfully',
  failureText: 'failed to load',
  completeText: 'loading completed'
};
exports.default = _default;